var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _stateSubscription, _states, _subscriptions, _updates, _workflow;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }
function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }
function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }
function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { Subject, Subscription } from 'rxjs';
import { filter, distinctUntilKeyChanged } from 'rxjs/operators';
import Service, { inject as service } from '@ember/service';
import { set } from '@ember/object';
import { CardStatus, Relationship } from '@square/dashboard-protos/models/squareup/bbdebit/cardmanagement';
import { updateLogger } from '@banking/ui/lib/workflow/update-logger';
import { createEmit, createSelect } from '@banking/ui/lib/workflow-ember/decorators';
import connect from '@banking/ui/lib/workflow-ember/connect';
import workflow, { createState, initializeAction, setActiveSettingAction, Setting } from '@banking/ui/workflows/card-settings';
import assert from '@banking/ui/utils/assert';
import { initializeAction as initializeBillingAddressAction, toggleModalAction } from '@banking/ui/workflows/card-settings/billing-address';
import { initializeAction as initializeResetPinAction, toggleModalAction as toggleResetPinModalAction } from '@banking/ui/workflows/card-settings/set-pin';
import { CancellationType, userClickCloseModalAction } from '@banking/ui/workflows/card-settings/cancel-card';
import { toggleModalByCardTokenAction as toggleActivateCardModalAction } from '@banking/ui/workflows/debit-card-activation';
import analytics from '@banking/ui/workflows/card-settings/analytics/analytics';
const SERVICE_REGISTRY_KEY = 'card-settings';
let CardSettingsState = (_dec = service('debit-card-activation-modal'), _dec2 = service('bbfrontend/v1/checking'), _dec3 = service('card-management/billing-address-modal'), _dec4 = service('bb-debit/card-management-service'), _dec5 = service('card-management/cancel-card-modal'), _dec6 = service('card-management/reset-pin-modal'), (_class = (_stateSubscription = /*#__PURE__*/new WeakMap(), _states = /*#__PURE__*/new WeakMap(), _subscriptions = /*#__PURE__*/new WeakMap(), _updates = /*#__PURE__*/new WeakMap(), _workflow = /*#__PURE__*/new WeakMap(), class CardSettingsState extends Service {
  constructor(...args) {
    super(...args);
    _classPrivateFieldInitSpec(this, _stateSubscription, {
      writable: true,
      value: null
    });
    _classPrivateFieldInitSpec(this, _states, {
      writable: true,
      value: new Subject()
    });
    _classPrivateFieldInitSpec(this, _subscriptions, {
      writable: true,
      value: new Subscription()
    });
    _classPrivateFieldInitSpec(this, _updates, {
      writable: true,
      value: new Subject()
    });
    _classPrivateFieldInitSpec(this, _workflow, {
      writable: true,
      value: void 0
    });
    _defineProperty(this, "state", createState());
    _initializerDefineProperty(this, "activateCardModalState", _descriptor, this);
    _initializerDefineProperty(this, "bbFrontendV1CheckingService", _descriptor2, this);
    _initializerDefineProperty(this, "billingAddressModalState", _descriptor3, this);
    _initializerDefineProperty(this, "bizbankApi", _descriptor4, this);
    _initializerDefineProperty(this, "cardManagementService", _descriptor5, this);
    _initializerDefineProperty(this, "cancelCardModalState", _descriptor6, this);
    _initializerDefineProperty(this, "dataApi", _descriptor7, this);
    _initializerDefineProperty(this, "resetPinModalState", _descriptor8, this);
    _initializerDefineProperty(this, "features", _descriptor9, this);
    _initializerDefineProperty(this, "router", _descriptor10, this);
    _initializerDefineProperty(this, "sentry", _descriptor11, this);
    _classPrivateFieldSet(this, _stateSubscription, _classPrivateFieldGet(this, _states).subscribe({
      next: state => set(this, 'state', state),
      error: error => this.sentry.captureException(error)
    }));
    _classPrivateFieldGet(this, _updates).subscribe(updateLogger('Card settings'));
    analytics(_classPrivateFieldGet(this, _updates)).subscribe(params => this.dataApi.track(...params));
    this.reset();
  }
  willDestroy() {
    this.deinitialize();
    _classPrivateFieldGet(this, _subscriptions).unsubscribe();
    super.willDestroy();
  }
  reset() {
    _classPrivateFieldGet(this, _subscriptions).unsubscribe();
    _classPrivateFieldSet(this, _subscriptions, new Subscription());
    _classPrivateFieldSet(this, _workflow, workflow(createState(), this.context));
    _classPrivateFieldGet(this, _subscriptions).add(_classPrivateFieldGet(this, _workflow).states.subscribe({
      next: next => _classPrivateFieldGet(this, _states).next(next),
      error: error => this.sentry.captureException(error)
    }));
    _classPrivateFieldGet(this, _subscriptions).add(_classPrivateFieldGet(this, _workflow).updates.subscribe(next => _classPrivateFieldGet(this, _updates).next(next)));
    // set setting to none when modal close
    _classPrivateFieldGet(this, _subscriptions).add(this.billingAddressModalState.states.pipe(distinctUntilKeyChanged('isOpen'), filter(({
      isOpen
    }) => !isOpen)).subscribe(() => {
      this.emit(setActiveSettingAction(Setting.None));
    }));
    _classPrivateFieldGet(this, _subscriptions).add(this.resetPinModalState.states.pipe(distinctUntilKeyChanged('isOpen'), filter(({
      isOpen
    }) => !isOpen)).subscribe(() => {
      this.emit(setActiveSettingAction(Setting.None));
    }));
    _classPrivateFieldGet(this, _subscriptions).add(this.cancelCardModalState.states.pipe(distinctUntilKeyChanged('modalOpen'), filter(({
      modalOpen
    }) => !modalOpen)).subscribe(() => {
      this.emit(setActiveSettingAction(Setting.None));
    }));
    _classPrivateFieldGet(this, _subscriptions).add(this.activateCardModalState.states.pipe(distinctUntilKeyChanged('isOpen'), filter(({
      isOpen
    }) => !isOpen)).subscribe(() => {
      this.emit(setActiveSettingAction(Setting.None));
    }));
  }
  emit(action) {
    _classPrivateFieldGet(this, _workflow).emit(action);
  }
  openBillingAddressModal(unitToken) {
    this.billingAddressModalState.emit(initializeBillingAddressAction(unitToken));
  }
  openResetPinModal(cardToken) {
    this.resetPinModalState.emit(initializeResetPinAction(cardToken));
  }

  /** *
   * There are 3 cancellation flows:
   * 1. If the current user is not the card holder, we're canceling an authorized user's card.
   * 2. If the current user is the card holder and their card is terminated, the only option is account termination.
   * 3. If the current user is the card holder and their card is not terminated, they can either cancel their account/card or reorder a new card.
   */
  openCancelCardModal() {
    const card = this.state.card;
    const cardCustomization = this.state.cardCustomization;
    const unitToken = this.router.currentRoute.params.unit_token;
    assert(card != null);
    assert(cardCustomization != null);
    assert(unitToken != null);
    let cancellationType;
    if (card.relationship.includes(Relationship.RELATIONSHIP_CARDHOLDER)) {
      cancellationType = card.status === CardStatus.CARD_STATUS_TERMINATED ? CancellationType.AccountHolderAccount : CancellationType.AccountHolderCard;
    } else {
      cancellationType = CancellationType.AuthorizedUserCard;
    }
    const balanceId = card.balanceId;
    this.cancelCardModalState.openModal(balanceId, card, cardCustomization, cancellationType, unitToken,
    // on successful cancel card, refetch card
    () => _classPrivateFieldGet(this, _workflow).emit(initializeAction(card.id, unitToken)));
  }
  openCardActivationModal() {
    const card = this.state.card;
    const unitToken = this.router.currentRoute.params.unit_token;
    assert(card != null);
    assert(unitToken != null);
    this.activateCardModalState.openModal(unitToken, card.id,
    // on successful cancel card, refetch card
    () => _classPrivateFieldGet(this, _workflow).emit(initializeAction(card.id, unitToken)));
  }
  closeActiveModal() {
    const {
      activeSetting
    } = this.state;
    switch (activeSetting) {
      case Setting.ActivateCard:
        {
          if (this.activateCardModalState.state.isOpen) {
            return this.activateCardModalState.emit(toggleActivateCardModalAction(false));
          }
          break;
        }
      case Setting.BillingAddress:
        return this.billingAddressModalState.emit(toggleModalAction(false));
      case Setting.CancelCard:
        {
          if (this.cancelCardModalState.state.modalOpen) {
            return this.cancelCardModalState.emit(userClickCloseModalAction());
          }
          break;
        }
      case Setting.ResetPin:
        {
          if (this.activateCardModalState.state.isOpen) {
            return this.resetPinModalState.emit(toggleResetPinModalAction(false));
          }
          break;
        }
      case Setting.None:
    }
  }
  get states() {
    return _classPrivateFieldGet(this, _states).asObservable();
  }
  deinitialize() {
    _classPrivateFieldGet(this, _subscriptions).unsubscribe();
    _classPrivateFieldGet(this, _stateSubscription)?.unsubscribe();
  }
  get context() {
    return {
      cardManagementService: this.cardManagementService.client,
      getCardCustomization: this.bizbankApi.client.getCardCustomization.bind(this.bizbankApi.client),
      getCheckingDirectDepositAccount: this.bbFrontendV1CheckingService.client.getCheckingDirectDepositAccount.bind(this.bbFrontendV1CheckingService.client),
      router: this.router,
      sentry: this.sentry
    };
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "activateCardModalState", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1CheckingService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "billingAddressModalState", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "bizbankApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "cardManagementService", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "cancelCardModalState", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "resetPinModalState", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { CardSettingsState as default };
export const select = createSelect(SERVICE_REGISTRY_KEY);
export const emit = createEmit(SERVICE_REGISTRY_KEY);
export const workflowComponent = connect(SERVICE_REGISTRY_KEY);